import { render, staticRenderFns } from "./im-custom-case.vue?vue&type=template&id=2bf72bda&scoped=true"
import script from "./im-custom-case.vue?vue&type=script&lang=js"
export * from "./im-custom-case.vue?vue&type=script&lang=js"
import style0 from "./im-custom-case.vue?vue&type=style&index=0&id=2bf72bda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf72bda",
  null
  
)

export default component.exports